"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountExperienceTransactionToJSON = exports.AccountExperienceTransactionFromJSONTyped = exports.AccountExperienceTransactionFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function AccountExperienceTransactionFromJSON(json) {
    return AccountExperienceTransactionFromJSONTyped(json, false);
}
exports.AccountExperienceTransactionFromJSON = AccountExperienceTransactionFromJSON;
function AccountExperienceTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'subject': (0, _1.AccountExperienceTransactionSubjectFromJSON)(json['subject']),
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
        'user': json['user'],
        'type': (0, _1.AccountExperienceTransactionTypeFromJSON)(json['type']),
        'amount': json['amount'],
        'community': !(0, runtime_1.exists)(json, 'community') ? undefined : json['community'],
        'overwolfRewardId': !(0, runtime_1.exists)(json, 'overwolfRewardId') ? undefined : json['overwolfRewardId'],
        'guildQuestId': !(0, runtime_1.exists)(json, 'guildQuestId') ? undefined : json['guildQuestId'],
    };
}
exports.AccountExperienceTransactionFromJSONTyped = AccountExperienceTransactionFromJSONTyped;
function AccountExperienceTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'subject': (0, _1.AccountExperienceTransactionSubjectToJSON)(value.subject),
        'notes': value.notes,
        'adminNotes': value.adminNotes,
        'user': value.user,
        'type': (0, _1.AccountExperienceTransactionTypeToJSON)(value.type),
        'amount': value.amount,
        'community': value.community,
        'overwolfRewardId': value.overwolfRewardId,
        'guildQuestId': value.guildQuestId,
    };
}
exports.AccountExperienceTransactionToJSON = AccountExperienceTransactionToJSON;
